import React from 'react';
import WaitingRoomPlayer from './WaitingRoomPlayer';
import { WaitingRoomPlayersInterface } from './WaitingRoomPlayersInterface';

function WaitingRoomTwoPlayers({players, isHost}: WaitingRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="twoPlayersWrapper1">
                <WaitingRoomPlayer name={players[1].name} image={players[1].image}/>
            </div>
            <div className="twoPlayersWrapper2">
                <WaitingRoomPlayer name={players[0].name} image={players[0].image}/>
            </div>
        </div>
    );
};

export default WaitingRoomTwoPlayers;